(function() {
  let sortInitialized = false;
  let buttonsInitialized = false;

  function initSortDropdown() {
    if (sortInitialized) return;
    const sortSelect = document.querySelector('.sort-by-dropdown select');
    if (sortSelect) {
      const urlParams = new URLSearchParams(window.location.search);
      const currentSort = urlParams.get('sort_by');
      if (currentSort) sortSelect.value = currentSort;
      sortSelect.addEventListener('change', function() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
      sortInitialized = true;
    }
  }

  function initButtonStyles() {
    if (buttonsInitialized) return;
    const buttons = document.querySelectorAll('.shop-add-to-cart-button');
    if (buttons.length > 0) {
      buttons.forEach(button => {
        button.style.setProperty('background-color', '#8B6F6F', 'important');
        button.style.setProperty('background', '#8B6F6F', 'important');
        button.style.setProperty('border-color', '#8B6F6F', 'important');
        button.style.setProperty('color', '#FFFFFF', 'important');
        button.style.setProperty('font-weight', '700', 'important');
        button.style.setProperty('text-transform', 'uppercase', 'important');
        button.style.setProperty('letter-spacing', '1.5px', 'important');
        button.addEventListener('mouseenter', function() {
          this.style.setProperty('background-color', '#7A5F5F', 'important');
          this.style.setProperty('background', '#7A5F5F', 'important');
        });
        button.addEventListener('mouseleave', function() {
          this.style.setProperty('background-color', '#8B6F6F', 'important');
          this.style.setProperty('background', '#8B6F6F', 'important');
        });
      });
      buttonsInitialized = true;
    }
  }

  function initAll() {
    initSortDropdown();
    initButtonStyles();
  }

  // Single observer that disconnects once both are done
  const observer = new MutationObserver(function() {
    initAll();
    if (sortInitialized && buttonsInitialized) {
      observer.disconnect();
    }
  });

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();